"use client";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import type { HomepageOptimizationV3TestResult } from "@/monarch/rules/homepageOptimizationV3/types";
import BaseHomepageHeroCategory from "./BaseHomepageHeroCategory";

export default function HomepageHeroCategory() {
  return (
    <MonarchDataConsumer<HomepageOptimizationV3TestResult>
      experimentKey="useHomepageOptimizationV3"
      render={(testResult) => {
        const { data } = testResult;
        const props = data?.sections?.[0] ?? {};
        return <BaseHomepageHeroCategory {...props} />;
      }}
    />
  );
}
